import admin from './componentsAPI/admin'


export default {
  admin,
}



// WEBPACK FOOTER //
// ./src/http/index.js